import React, {Component} from 'react'
import {Button, Container, Row, Col, Card, CardHeader, CardBody} from 'reactstrap'

import Undertime from './Undertime'
import Agenda from "./Agenda";
import ProjectsLast30DaysChart from './ProjectsLast30DaysChart'


class Index extends Component {

    static getDerivedStateFromProps(props, state){

        const {user} = JSON.parse(sessionStorage.getItem('user'))

        return {
            user
        }
    }

    render() {
        return (
            <Container fluid className="pt-4">

                <Row className="mb-4">
                    <Col>
                        <Card>
                            <CardHeader>Project Time (Last 30 Days)</CardHeader>
                            <CardBody> 
                                <ProjectsLast30DaysChart/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col sm={3}>
                        <Undertime user_id={this.state.user.user_id}/>
                    </Col>
                    <Col sm={9}>
                        <Agenda user_id={this.state.user.user_id}/>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default Index